import {Fragment, useEffect} from 'react';
import {Settings, ChangeFunction} from '../../types';
import {SettingsPanel} from '@esgi/main/kits/reports';
import {Wrapper, CheckboxGroup, CheckboxGroupItem, Link} from './index.styled';
import {Info} from '@esgi/ui/icons';

interface Props {
	disabled?: boolean;
	value?: Settings;
	onChange: ChangeFunction<Settings>;
}

type Group = [string, string, string][];

const groups: Group[] = [
	[
		['baseline', 'Show Baseline', ''],
		['summary', 'Show Summary', ''],
		['notes', 'Show Notes', ''],
	],
	[
		['forward', 'Carry Forward', 'hint'],
	],
];

export function SettingsControl(props: Props) {
	const {disabled, value, onChange} = props;

	useEffect(() => {
		if (typeof value === 'undefined') {
			onChange({
				baseline: true,
				summary: false,
				notes: false,
				forward: false,
			});
		}
	}, []);

	return (
		<SettingsPanel title='Settings'>
			{groups.map((group, index) =>
				<Wrapper key={index}>
					<CheckboxGroup column={group.length === 1 && Boolean(group[0][2].length)}>
						{group.map(([key, label, hint]) =>
							<Fragment key={key}>
								<CheckboxGroupItem
									disabled={disabled}
									label={label}
									checked={value[key]}
									onCheckedChange={(checked) => onChange({...value, [key]: checked})}
								/>
								{hint &&
									<Link
										href='https://support.esgisoftware.com/hc/en-us/articles/360024667492-Student-Detail-Report'
										target='_blank'
										rel='noreferrer'
									>
										<Info/>
									</Link>
								}
							</Fragment>
						)}
					</CheckboxGroup>
				</Wrapper>
			)}
		</SettingsPanel>
	);
}
